/** @flow */
import {
  GetSupplierNewReferrals,
  GetSupplierNewReferralsSuccess,
  GetSupplierNewReferralsError,
  GetSupplierActiveReferrals,
  GetSupplierActiveReferralsSuccess,
  GetSupplierActiveReferralsError,
  GetSupplierClosedReferrals,
  GetSupplierClosedReferralsSuccess,
  GetSupplierClosedReferralsError,
  ToggleSupplierReferralDetailsModal,
  GetSupplierReferralDetails,
  GetSupplierReferralDetailsSuccess,
  GetSupplierReferralDetailsError,
  SubmitSupplierReferralStatus,
  SubmitSupplierReferralStatusSuccess,
  SubmitSupplierReferralStatusError,
  GetSupplierClosedReferralsStatusesSuccess,
  GetSupplierClosedReferralsStatusesError,
  //RTW
  ToggleRTWReferralDetailsModal,
  GetRTWReferralDetails,
  GetRTWReferralDetailsSuccess,
  GetRTWReferralDetailsError,
  SubmitRTWReferralData,
  SubmitRTWReferralDataSuccess,
  SubmitRTWReferralDataError,
  //Log
  ToggleLogReferralDetailsModal,
  SubmitLogReferralDataSuccess,
  GetLogReferralDetails,
  SubmitLogReferralData,
  GetLogReferralDetailsSuccess,
  GetLogReferralDetailsError,
  SetReferralCommonData,
  //Status
  ToggleStatusReferralDetailsModal,
  // Outcomes
  GetReferralOutcomesReport,
  GetReferralOutcomesReportSuccess,
  GetReferralOutcomesReportError,
  ExportReferralOutcomesReport,
  ExportReferralOutcomesReportSuccess,
  ExportReferralOutcomesReportError,
  // Manager KPI
  GetManagerKpiReport,
  GetManagerKpiReportSuccess,
  GetManagerKpiReportError,
  ExportManagerKpiReport,
  ExportManagerKpiReportSuccess,
  ExportManagerKpiReportError,
} from "@modules/reporting/constants/actions";
import * as reducers from "./reducers";
import initialState from "./state";
import type { ReferralTrackerState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: ReferralTrackerState = initialState, action: *): ReferralTrackerState => {
  const act = {
    // New Referrals
    [GetSupplierNewReferrals]: reducers.setLoading,
    [GetSupplierNewReferralsSuccess]: reducers.onGetSupplierNewReferralsSuccess,
    [GetSupplierNewReferralsError]: reducers.onGetSupplierNewReferralsError,
    // Active Referrals
    [GetSupplierActiveReferrals]: reducers.setLoading,
    [GetSupplierActiveReferralsSuccess]: reducers.onGetSupplierActiveReferralsSuccess,
    [GetSupplierActiveReferralsError]: reducers.onGetSupplierActiveReferralsError,
    // Closed Referrals
    [GetSupplierClosedReferrals]: reducers.setLoading,
    [GetSupplierClosedReferralsSuccess]: reducers.onGetSupplierClosedReferralsSuccess,
    [GetSupplierClosedReferralsError]: reducers.onGetSupplierClosedReferralsError,
    // Closed Referrals Statuses
    [GetSupplierClosedReferralsStatusesSuccess]:
      reducers.onGetSupplierClosedReferralsStatusesSuccess,
    [GetSupplierClosedReferralsStatusesError]: reducers.onGetSupplierClosedReferralsStatusesError,
    // Referrals Details
    [GetSupplierReferralDetails]: reducers.setLoading,
    [GetSupplierReferralDetailsSuccess]: reducers.onGetSupplierReferralDetailsSuccess,
    [GetSupplierReferralDetailsError]: reducers.onGetSupplierReferralDetailsError,
    [ToggleSupplierReferralDetailsModal]: reducers.onToggleSupplierReferralDetailsModal,
    [SubmitSupplierReferralStatus]: reducers.setLoading,
    [SubmitSupplierReferralStatusSuccess]: reducers.onSubmitSupplierReferralStatusSuccess,
    [SubmitSupplierReferralStatusError]: reducers.onSubmitSupplierReferralStatusError,
    // RTW
    [GetRTWReferralDetails]: reducers.setLoading,
    [GetRTWReferralDetailsSuccess]: reducers.onGetRTWReferralDetailsSuccess,
    [GetRTWReferralDetailsError]: reducers.onGetRTWReferralDetailsError,
    [ToggleRTWReferralDetailsModal]: reducers.onToggleRTWReferralDetailsModal,
    // Log
    [GetLogReferralDetails]: reducers.setLoading,
    [GetLogReferralDetailsSuccess]: reducers.onGetLogReferralDetailsSuccess,
    [GetLogReferralDetailsError]: reducers.onGetLogReferralDetailsError,
    [SubmitLogReferralData]: reducers.setLoading,
    [SubmitLogReferralDataSuccess]: reducers.onSubmitLogReferralDataSuccess,
    [ToggleLogReferralDetailsModal]: reducers.onToggleLogReferralDetailsModal,
    [SubmitRTWReferralData]: reducers.setLoading,
    [SubmitRTWReferralDataSuccess]: reducers.onSubmitRTWReferralDataSuccess,
    [SubmitRTWReferralDataError]: reducers.onSubmitRTWReferralDataError,
    [SetReferralCommonData]: reducers.onSetReferralCommonData,
    //Status
    [ToggleStatusReferralDetailsModal]: reducers.onToggleStatusReferralDetailsModal,
    // Outcomes
    [GetReferralOutcomesReport]: reducers.setLoading,
    [GetReferralOutcomesReportSuccess]: reducers.onGetReferralOutcomesReportSuccess,
    [GetReferralOutcomesReportError]: reducers.onError,
    [ExportReferralOutcomesReport]: reducers.setLoading,
    [ExportReferralOutcomesReportSuccess]: reducers.setLoaded,
    [ExportReferralOutcomesReportError]: reducers.onError,
    // Manager KPI
    [GetManagerKpiReport]: reducers.setLoading,
    [GetManagerKpiReportSuccess]: reducers.onGetManagerKpiReportsSuccess,
    [GetManagerKpiReportError]: reducers.onError,
    [ExportManagerKpiReport]: reducers.setLoading,
    [ExportManagerKpiReportSuccess]: reducers.setLoaded,
    [ExportManagerKpiReportError]: reducers.onError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
